import { usePWAInstall } from "@/hooks/usePWAInstall";
import { X, Share, PlusSquare, CheckCircle2 } from "lucide-react";

export default function IOSInstallGuide() {
  const { showIOSGuide, dismissInstall } = usePWAInstall();

  if (!showIOSGuide) return null;

  const steps = [
    { icon: Share, label: "Tap the Share button", sub: "in Safari's toolbar" },
    { icon: PlusSquare, label: 'Tap "Add to Home Screen"', sub: "scroll down if needed" },
    { icon: CheckCircle2, label: 'Tap "Add"', sub: "to confirm" },
  ];

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] animate-in slide-in-from-bottom duration-300">
      <div className="mx-auto max-w-md rounded-2xl border border-border bg-card p-4 shadow-xl">
        <div className="flex items-center justify-between mb-3">
          <p className="font-semibold text-foreground text-sm">Install ACEX</p>
          <button
            onClick={dismissInstall}
            className="rounded-full p-1 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="space-y-3">
          {steps.map((step, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <step.icon className="h-4 w-4" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{step.label}</p>
                <p className="text-xs text-muted-foreground">{step.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
